import { Label, Stack } from "@fluentui/react";
import { IComponentDataItem } from "../Components/DynamicFormRendering";

export function CustomViewModeComponent(props: IComponentDataItem) {
    return (
        <Stack className='display:flex;flex-direction:row;display:inline'>
            <Label className="CustomViewModeComponentLabel" key={props.id}> {props?.label} </Label>
        </Stack>
    );
}